import React from 'react';
import { Button } from './ui/Button';
import { ShieldCheck, Zap, Smartphone } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-gradient-to-b from-emerald-50 to-stone-50 pt-16 pb-20 lg:pt-24 lg:pb-28" data-id="element-145">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-146">
        <div className="lg:grid lg:grid-cols-12 lg:gap-8 items-center" data-id="element-147">
          {/* Text Content */}
          <div className="lg:col-span-6 text-center lg:text-left mb-12 lg:mb-0" data-id="element-148">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-gray-900 tracking-tight mb-6 leading-tight" data-id="element-149">
              Desinflamá tu vientre en{' '}
              <span className="text-emerald-600" data-id="element-150">28 días</span> sin dietas, sin
              prohibiciones y sin dejar lo que te gusta
            </h1>

            <p className="text-xl sm:text-2xl text-emerald-800 font-medium mb-6" data-id="element-151">
              Comé rico. Sentite liviana. Volvé a tener energía.
            </p>

            <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-152">
              Con el único método que ordena tu digestión desde adentro — sin
              que tengas que cambiar tu vida entera para lograrlo.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mb-4" data-id="element-153">
              <a href="https://www.elplacerquenutre.com//cart/44835922083942:1" className="w-full sm:w-auto" onClick={e => trackAddToCart(e)} data-id="element-154">
                <Button size="xl" withArrow className="w-full sm:w-auto shadow-emerald-200/50" data-id="element-155">
                  QUIERO EMPEZAR EL RETO AHORA
                </Button>
              </a>
            </div>

            <div className="text-center lg:text-left mb-8" data-id="element-156">
              <p className="text-xl md:text-2xl font-bold text-gray-900" data-id="element-157">
                $14,997 con el 50% desc
              </p>
              <p className="text-sm font-medium text-gray-500" data-id="element-158">
                Pago único — sin suscripciones
              </p>
            </div>

            <div className="flex flex-wrap justify-center lg:justify-start gap-4 text-sm font-medium text-gray-500" data-id="element-159">
              <div className="flex items-center" data-id="element-160">
                <ShieldCheck className="w-4 h-4 text-emerald-600 mr-1.5" data-id="element-161" />
                Garantía 7 días
              </div>
              <div className="flex items-center" data-id="element-162">
                <Zap className="w-4 h-4 text-emerald-600 mr-1.5" data-id="element-163" />
                Acceso inmediato
              </div>
              <div className="flex items-center" data-id="element-164">
                <Smartphone className="w-4 h-4 text-emerald-600 mr-1.5" data-id="element-165" />
                100% digital
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="lg:col-span-6 relative" data-id="element-166">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl transform rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-167">
              <img src="https://cdn.magicpatterns.com/uploads/hcL3SC78wYPpdsFS7nXWqR/ChatGPT_Image_22_ene_2026,_18_40_10_(1)_(1).png" alt="Mujer feliz comiendo saludable y sonriendo" className="w-full h-auto object-cover" data-id="element-168" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" data-id="element-169"></div>
            </div>

            {/* Floating Badge */}
            <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-lg hidden md:block animate-bounce-slow" data-id="element-170">
              <div className="flex items-center gap-3" data-id="element-171">
                <div className="bg-emerald-100 p-2 rounded-full" data-id="element-172">
                  <Zap className="w-6 h-6 text-emerald-600" data-id="element-173" />
                </div>
                <div data-id="element-174">
                  <p className="text-xs text-gray-500 font-bold uppercase" data-id="element-175">
                    Resultados
                  </p>
                  <p className="text-sm font-bold text-gray-900" data-id="element-176">
                    Desde la 1ª semana
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}